import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL =
	window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

const Login = () => {
	const [form, setForm] = useState({ password: '', email: '' });
	const [error, setError] = useState('');
	const navigate = useNavigate();

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
		setError('');
	};

	const handleLogin = async (e) => {
		e.preventDefault();
		setError('');
		// Only check for required fields (HTML5 will also enforce this)
		if (!form.email.trim()) {
			setError('Both fileds are required');
			return;
		}
		try {
			const res = await axios.post(`${BASE_URL}/api/auth/login-or-register`, JSON.stringify(form), {
				headers: {
					'Content-Type': 'application/json',
				},
			});
			if (res.data.success) {
				sessionStorage.setItem('token', res.data.data.token);
				sessionStorage.setItem('userId', res.data.data.user.id); // Store user ID
				sessionStorage.setItem('userRole', res.data.data.user.role); // Store user role
				sessionStorage.setItem('userName', res.data.data.user.name);

				// Fetch latest/draft application for this user
				// let hasDraft = false;
				let lastStep = 0;
				try {
					const appRes = await axios.get(`${BASE_URL}/api/application/draft`, {
						headers: {
							Authorization: `Bearer ${res.data.data.token}`,
						},
					});

					// console.log('📝 Draft application response:', appRes.data.success, appRes.data);
					// console.log(appRes.data.data);
					const applicationData = appRes.data.data;
					if (applicationData.applicationId) {
						sessionStorage.setItem('applicationId', applicationData.applicationId);
						sessionStorage.setItem('status', applicationData.status);
						// If backend provides lastStep, store it; else default to 0
						if (typeof applicationData.lastStep === 'number') {
							lastStep = applicationData.lastStep;
							sessionStorage.setItem('lastStep', lastStep);
						}
						if (
							applicationData.status === 'Submitted' ||
							applicationData.status === 'Selected' ||
							applicationData.status === 'Rejected' ||
							applicationData.status === 'Annexure Received' ||
							applicationData.status === 'Accepted'
						) {
							navigate('/applicationstatus?status=' + applicationData.status);
							return;
						} else if (applicationData.status === 'Sent for Annexure') {
							navigate('/submitdocuments');
							return;
						}
						//hasDraft = true;
						navigate('/applicationdraft');
					} else {
						window.location.href = '/form';
					}
				} catch (appErr) {
					console.warn('⚠️ Could not fetch draft application:', appErr.message);
				}

				// console.log("✅ Login successful:", hasDraft);

				// if (hasDraft) {
				// 	navigate('/applicationdraft');
				// } else {
				// 	window.location.href = '/form';
				// }
			} else {
				setError(res.data.message || 'Login failed');
			}
		} catch (err) {
			console.error('❌ Login error:', err);
			setError(err.response?.data?.message || err.message || 'Login failed');
			toast.error(err.response?.data?.message || err.message || 'Login failed');
			// navigate("/");
		}
	};

	return (
		<div className="container container_cust">
			<Row>
				<Col xl="12">
					<h2 className="personalinfo_head2">Fellowship Application</h2>
				</Col>
			</Row>

			<Row>
				<Col xl="4">
					<div className="formbg">
						<h3>Login</h3>
						{/* <p>Enim tempor eget pharetra facilisis sed maecenas adipiscing. </p> */}

						<form onSubmit={handleLogin}>
							<div className="form-floating mb-3 mt-3">
								<input
									type="email"
									className="form-control form_cap form_custom"
									id="email"
									placeholder="Enter Email*"
									name="email"
									value={form.email}
									onChange={handleChange}
									required
								/>
								<label htmlFor="emailOrMobile">
									Email <span className="text-danger">*</span>
								</label>
							</div>
							<div className="form-floating mb-3 mt-3">
								<input
									type="password"
									className="form-control form_cap form_custom"
									id="password"
									placeholder="Enter Password"
									name="password"
									value={form.password}
									onChange={handleChange}
									required
								/>
								<label htmlFor="name">
									Password <span className="text-danger">*</span>
								</label>
							</div>

							<div style={{ color: '#343a40', marginTop: 10 }}>
								<a href="/forgotpassword" style={{ textDecoration: 'none', color: '#FF5C36' }}>
									Forgot Password?
								</a>
							</div>

							<button className="login_btn" type="submit">
								LOGIN
							</button>
							{/* <ToastContainer position="bottom-left" autoClose={3000} /> */}

							<div style={{ color: '#343a40', marginTop: 10 }}>
								<p>
									New Applicant?{' '}
									<a href="/" style={{ textDecoration: 'none', color: '#FF5C36' }}>
										Sign Up
									</a>
								</p>
							</div>

							{error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
						</form>
					</div>
				</Col>

				<Col xl="8">
					<div className="login_content">
						<h4>Fellowship Application Timeline</h4>
						<h5>Deadline </h5>
						<p>
							Completed applications must be submitted by <span>December 10, 2025.</span>
						</p>
						<h5>Selection</h5>
						<p>
							Applicants will be notified of their acceptance status by <span>December 24, 2025.</span>
						</p>
						<p>
							Selected applicants must confirm their acceptance of the fellowship offer by{' '}
							<span>December 31, 2025.</span>
						</p>
						<h5>Commencement</h5>
						<p>
							The fellowship officially begins on <span>January 1, 2026.</span>
						</p>
						<p>
							We encourage meaningful voices to join us in contributing to and enriching the narrative surrounding
							India's journey forward!
						</p>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default Login;
